import React, { createContext, ReactNode, useContext, useState } from 'react';

interface MainLayoutContextProps {
  headerContent: React.ReactNode;
  setHeaderContent: (content: React.ReactNode) => void;
  contentClassName: string | null;
  setContentClassName: (className: string | null) => void;
}

const MainLayoutContext = createContext<MainLayoutContextProps | undefined>(undefined);

export const useMainLayout = (): MainLayoutContextProps => {
  const context = useContext(MainLayoutContext);
  if (!context) {
    throw new Error('useMainLayout must be used within a MainLayoutProvider');
  }
  return context;
};

interface MainLayoutProviderProps {
  children: ReactNode;
}

export const MainLayoutProvider: React.FC<MainLayoutProviderProps> = ({ children }) => {
  const [headerContent, setHeaderContent] = useState<React.ReactNode>(null);
  const [contentClassName, setContentClassName] = useState<string | null>(null);

  return (
    <MainLayoutContext.Provider
      value={{
        headerContent,
        setHeaderContent,
        contentClassName,
        setContentClassName,
      }}
    >
      {children}
    </MainLayoutContext.Provider>
  );
};
